module.exports = __webpack_public_path__ + "img/realized.32dd1a0e.svg";